<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
  <a-tabs v-model:activeKey="activeKey">
        <a-tab-pane :key="1" tab="码批次">
          <list type="normal" />
        </a-tab-pane>
        <a-tab-pane :key="2" tab="禁用管理">
          <list  type="ban" />
        </a-tab-pane>
        <a-tab-pane :key="3" tab="商品赋码管理">
          <product />
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template> 
<script>
import list from './components/list/index'
import product from './components/product/index'
import {inject, onMounted, ref} from 'vue'
export default {
  components:{list,product},
  name: "batch",
  setup() {
      const activeKey=ref(1)
      const $route=inject('$route')
    onMounted(()=>{
        if($route.query.active){
            activeKey.value=Number($route.query.active)
        }
    })
      return{
        activeKey
      }
  },
};
</script>